export default __webpack_public_path__ + "static/media/dashboard-doctor-top-img.81f2f65e.png";